import {AfterViewInit, Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

import {SelectItem} from 'primeng/primeng';
import {Message} from "primeng/components/common/api";
import {Table} from "primeng/table";

import {AwsService} from "../aws.service";
import {Data} from "../../api/model/data";
import {Schema} from "../../api/model/schema";
import {Utils} from '../utils';
import {config} from '../config';

import {CodemirrorService} from '@nomadreservations/ngx-codemirror';

import 'codemirror/addon/lint/lint.css';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/addon/lint/lint';
import 'codemirror/addon/lint/json-lint';

import * as Ajv from 'ajv';
import * as _ from 'lodash';
import * as Papa from 'papaparse';
import * as jsyaml from 'js-yaml';

const slugize = require('hexo-util/lib/slugize');

@Component({
    template: require('./data-form.component.pug'),
    styles: [require('./data-form.component.css')]
})
export class DataFormComponent implements OnInit, AfterViewInit {
    msgs: Message[] = [];

    @ViewChild('tt') tt: Table;
    action: string = 'create';
    siteId: string;

    model: Data = {};

    ajv: Ajv.Ajv = new Ajv();
 
    values: any[] = [];
    cols: any[] = [];

    layouts: SelectItem[] = [];
    layout: string;

    schemas: SelectItem[] = [];
    schema: Schema = {};

    form: any = {};

    formDialog: boolean = false;

    extensions: string[] = ['csv', 'json', 'yml'];

    namePattern: RegExp = /[\w]+/;

    selectedRow: number = -1;

    constructor(private route: ActivatedRoute, private _awsService: AwsService) {
        console.log('[DataFormComponent][constructor]');
        this.siteId = localStorage.getItem('currentSite');
    }

    async ngOnInit() {
        try {
            const site = (await this._awsService.api.sitesSiteGet({site: this.siteId})).data;
            const schemas = (await this._awsService.api.sitesSiteSchemasGet({site: this.siteId})).data.items;
            this.schemas.push({label: 'Selecciona un esquema', value: null});
            schemas.forEach((schema:any) => this.schemas.push({label: schema.name, value: schema}))

            const theme = (await this._awsService.api.sitesSiteThemesNameGet({site: this.siteId, name: site.theme})).data;
            for (let layout of theme.layouts) this.layouts.push({label: layout, value: layout});
            

            let id = this.route.snapshot.paramMap.get("id");
            if (id !== "new") {
                this.model = (await this._awsService.api.sitesSiteDatasNameGet({site: this.siteId, name: id})).data;
                if (this.model.schema) {
                    const schema:any = _.find(schemas, {name: this.model.schema});
                    if (schema) {
                        this.form.schema = JSON.parse(schema.schema);
                        this.form.layout = JSON.parse(schema.layout);
                        this.form.data = (schema.data) ? JSON.parse(schema.data) : {};
                        this.schema = schema;
                    }
                }
                const s3 = new this._awsService.AWS.S3(this._awsService.credentials);
                const key = config.S3_PREFIX + this._awsService.identityId + '/datas/dn/' + this.model.name + '.json';
                const params = {Bucket: config.S3_BUCKET, Key: key};
                const res = await s3.getObject(params).promise();
                this.initDataTable(JSON.parse(res.Body.toString()));
                this.action = 'update';
            }
        } catch(err) {
            this.msgs.push({severity: 'error', summary: 'Erroe en la carga', detail: err}); 
        }
    }

    ngAfterViewInit(): void {
        console.log('[DataFormComponent][ngAfterViewInit]');
    }

    async onSubmit(event: any) {
        console.log('[DataFormComponent][onSubmit]', event)
        const validate = this.ajv.compile(JSON.parse(this.schema.schema));
        const valid = validate(event);
        if (valid) {
            if (this.selectedRow >= 0) {
                this.values[this.selectedRow] = event;
                this.selectedRow = -1;
            } else {
                this.values.push(event);
            }
            this.formDialog = false;
        } else {
            console.log('NOT VALID');
        }
    }

    onChangeSchema(event:any) {
        if (!event.value) {
            this.form = {};
            return;
        }
        this.form.schema = JSON.parse(event.value.schema);
        this.form.layout = JSON.parse(event.value.layout);
        this.form.data = JSON.parse(event.value.data);
        this.model.schema = this.schema.name;
        this.initColumns(this.form.schema.properties);
    }

    initColumns(obj: any) {
        const keys = Object.keys(obj);
        const len = (keys.length) <= 3 ? keys.length : 3;
        for (let i = 0; i < len; i++) {
            const prop = obj[keys[i]];
            const header = (prop.title) ? prop.title : _.upperFirst(keys[i]);
            this.cols.push({field: keys[i], header: header});
        }
        console.log(this.cols);
    }

    async save() {
        if (!this.model.name) {
            this.msgs.push({severity: 'error', summary: 'El nombre es obligatorio'});
            console.log('El nombre es obligatorio', this.model);
            return;
        }
        if (!this.values.length) {
            this.msgs.push({severity: 'error', summary: 'No hay datos'});
            console.log('No hay datos');
            return;                
        }
        if (this.form.schema) {
            console.log(this.form.schema);
            const validate = this.ajv.compile(this.form.schema);
            let errors = 0;
            for (let i = 0; i < this.values.length; i++) {
                let value = this.values[i];
                const valid = validate(value);
            }
            if (errors) {
                this.msgs.push({severity: 'error', summary: 'Datos invalidos: ' + errors});
                console.log('Datos invalidos: ' + errors);
                return;                                    
            }
        }
        try {
            const s3 = new this._awsService.AWS.S3(this._awsService.credentials);
            const key = config.S3_PREFIX + this._awsService.identityId + '/datas/up/' + this.model.name + '.json';
            const params = {Bucket: config.S3_BUCKET, Key: key, Body: JSON.stringify(this.values), ACL: 'public-read'};
            await s3.upload(params).promise();
            if (this.action === 'create') {
                try {
                    await this._awsService.api.sitesSiteDatasNameHead({site:this.siteId, name: this.model.name});
                    this.msgs.push({severity: 'error', summary: 'Nombre de dato ya existe'});
                } catch(err) {}
                this.model = (await this._awsService.api.sitesSiteDatasPost({site:this.siteId}, this.model)).data;
                this.action = 'update';
            } else if (this.action === 'update') {
                this.model = (await this._awsService.api.sitesSiteDatasNamePut({site:this.siteId, name: this.model.name}, this.model)).data;
            }
        } catch(err) {
            this.msgs.push({severity: 'error', summary: 'Error al guardar'});
        }
    }

    async uploadHandler(event: any, uploader: any) {
        console.log('[DataFormComponent][uploadHandler]', event.files[0]);
        this.msgs = [];

        let ext = Utils.extension(event.files[0].name);
        if (this.extensions.indexOf(ext) < 0) {
            this.msgs.push({severity: 'error', summary: 'Error: el tipo de eschivo es incorrecto, solo se acepta CSV, YAML o JSON'});
            uploader.clear();
            return;
        }

        let values: any;
        try {
            if (ext === 'csv') {
                let data = await this.parseCsv(event.files[0]);
                console.log(data);
                values = data.data;
            } else if (ext === 'yml') {
                values = await this.parseYaml(event.files[0]);
            } else if (ext === 'json') {
                values = await this.parseJson(event.files[0]);
            }
        } catch(err) {
            this.msgs.push({severity: 'error', summary: 'Error en el formato del archivo', detail: err});
            uploader.clear();
            return;
        }
        console.log(values);
        if (!values || !_.isArray(values)) {
            this.msgs.push({severity: 'error', summary: 'El archivo está vacio o no es un listado'});
            uploader.clear();
            return;
        }

        this.initDataTable(values);
        uploader.clear();
    }

    parseCsv(file: File): Promise<any> {
        return new Promise((resolve, reject) => {
            Papa.parse(file, {
                header: true,
                complete: (results) => {
                    resolve(results);
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }

    parseYaml(file: File): Promise<any> {
        return new Promise((resolve, reject) => {
            let fr = new FileReader();
            fr.readAsText(file);
            fr.onload = (event: Event) => {
                try {
                    const target: any = event.target;
                    resolve(jsyaml.safeLoad(target.result));
                } catch (err) {
                    reject(err);
                }
            };
            fr.onerror = (err) => {
                reject(err);
            };
        });
    }

    parseJson(file: File): Promise<any> {
        return new Promise((resolve, reject) => {
            let fr = new FileReader();
            fr.readAsText(file);
            fr.onload = (event: Event) => {
                try {
                    const target: any = event.target;
                    resolve(JSON.parse(target.result));
                } catch (err) {
                    reject(err);
                }
            };
            fr.onerror = (err) => {
                reject(err);
            };
        });
    }

    initDataTable(values:any[]) {
        const obj = (this.form.schema) ? this.form.schema.properties : values[0];
        const keys = Object.keys(obj);
        const len = (keys.length) <= 3 ? keys.length : 3;
        for (let i = 0; i < len; i++) {
            const prop = obj[keys[i]];
            const header = (prop.title) ? prop.title : _.upperFirst(keys[i]);
            this.cols.push({field: keys[i], header: header});
        }
        console.log(this.cols);
        this.values = values;
    }

    newRow() {
        if (this.schema && this.schema.data) this.form.data = JSON.parse(this.schema.data);
        this.selectedRow = -1;        
        this.formDialog = true;
    }

    removeRow(rowIndex: number) {
        console.log(rowIndex);
        this.values.splice(rowIndex, 1);
    }

    editRow(rowIndex: number) {
        console.log('[DataFormComponent][editRow]', this.values[rowIndex]);
        this.form.data = this.values[rowIndex];
        this.selectedRow = rowIndex;
        this.formDialog = true;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/datas/data-form.component.ts